import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
    ButtonBase,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE from '../../../../static/modern-professional/GalleryLambda-Slide-Issue.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import A8Agoda from '../components/A8/modern-proffesional/A8Agoda';

import FemaleIcon from '@mui/icons-material/Female';
import IconButton from '@mui/material/IconButton';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import WomanIcon from '@mui/icons-material/Woman';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import GameCard from '../components/GameCard';


// Article Specific Consts: Start
export const ARTICLE_URL_PATH = "/net-supermarket";
export const ARTICLE_TITLE = "asdf";
export const ARTICLE_DATE = "2024 Jan 27th";
// Article Specific Consts: end


interface ArticlePageProps {
    path: string;
}


const ListeningGame: React.FC<ArticlePageProps> = ({ path }) => {
    return (
        <GameCard
            path="test"
        />
    );
};

export default ListeningGame;
